module.exports = "/assets/_next/static/images/incomplete-patronus-f46c2ab9b7c3809d2d30d4775721c21c.png";